import { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { useDispatch, useSelector } from 'react-redux';
import { forgot, ILoginState } from '@share/store/slices';
import { Toaster } from '@share/utils';

const { Option } = Select;

const AddTeamMember = (props: any) => {
  const { isOpen, setIsOpen, dptRoles, userData, onSaveSuccess, departments } = props;
  const login = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { account } = login;
  const buttonColor = account?.buttonColor;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);


    const handleSendEmail = (user: any) => {
      setForgotLoading(true);
      if(user?.email) {
        dispatch(forgot(user.email)); 
        setTimeout(() => {
          setIsOpen(false);
          setForgotLoading(false);
        }, 1000);
      }
      else {
        Toaster.error('User does not have email');
        setTimeout(() => {
          setIsOpen(false);
          setForgotLoading(false);
        }, 1000);
      }
  }
  
  const onFinish = async (values: any) => {
    values.accountId = userData?.accountId;
    values.userId = userData?.userId;
    setLoading(true);
    try {
      await onSaveSuccess(values);
      setIsOpen(false);
    } catch (error) {
      console.error('Error parsing hotels data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userData) {
      form.setFieldsValue(userData);
    }
  }, [userData]);
  
  return (
    <Modal
      visible={isOpen}
      title={userData?.email ? 'Edit Team Member' : 'Add New Team Member'}
      onCancel={() => setIsOpen(false)}
      footer={[
        <div className="p-2 d-flex justify-content-end align-items-center">
          <BlueButton 
            block
            size="large"
            type="primary"
            key="cancel"
            className={`btn mb-0 commonBlueBtn ${buttonColor ? '' : 'commonBlueBtn_Outline'}`}
            onClick={() => setIsOpen(false)}
          >
            <FormattedMessage id="cancel.button" />
          </BlueButton>
           {userData?.email && <BlueButton
            block
            size="large"
            className="btn btn-primary commonBlueBtn"
            onClick={() => handleSendEmail(userData)}
            loading={forgotLoading}
              style={{width : "216px", height : "40px" }}
          >
            {forgotLoading ? <Spin spinning={forgotLoading}/> : <FormattedMessage id="resend.password" />}
          </BlueButton>}
          <BlueButton
            block
            size="large"
            type="primary"
            key="submit"
            htmlType="submit"
            className="btn btn-primary commonBlueBtn"
            onClick={form.submit}
            loading={loading}
          >
            <FormattedMessage id="save.changes" />
          </BlueButton>
        </div>,
      ]}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          initialValues={{ state: userData?.state || 'Active' }}
          onFinish={onFinish}
          layout="vertical"
        >
          <div className="flex-container">
            <Form.Item
              label="First Name"
              name="firstName"
              rules={[{ required: true, message: 'Please enter first name' }]}
            >
              <Input placeholder="First name" className="form-control form-control-lg" />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="lastName"
              rules={[{ required: true, message: 'Please enter last name' }]}
            >
              <Input placeholder="Last name" className="form-control form-control-lg" />
            </Form.Item>
          </div>
          <Form.Item
            label="Company Email"
            name="email"
            rules={[
              { required: true, message: 'Please enter company email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input
              type="email"
              placeholder="Enter Email"
              className="form-control form-control-lg"
            />
          </Form.Item>
          <Form.Item label="State" name="state">
            <Select defaultValue="Active" className="customSelect">
              <Option value="Active">Active</Option>
              <Option value="Locked">Locked</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Role"
            name="role"
            rules={[{ required: true, message: 'Please select role' }]}
          >
            <Select placeholder="Select role" className="customSelect">
              {dptRoles?.items?.map((role: any, index: number) => (
                <Option key={index} value={role.id}>{role?.description}</Option>))}
            </Select>
          </Form.Item>
          {!!departments?.length && (
            <Form.Item
              label="Department"
              name="departmentId"
              rules={[{ required: true, message: 'Please select department' }]}
            >
              <Select placeholder="Select department" className="customSelect">
                {departments?.map((departments: any, index: number) => (
                  <Option key={index} value={departments.departmentId}>{departments?.departmentName}</Option>))}
              </Select>
            </Form.Item>)}
        </Form>
      </Spin>
    </Modal>
  );
};

export { AddTeamMember };
